import product1 from '../../img/ordi1.jpg';
import product2 from '../../img/ordi2.jpg';
import product3 from '../../img/ensemble.jpg';
import sweet1 from '../../img/clavier.jpg';
import sweet2 from '../../img/focus.jpg';
import sweet3 from '../../img/business1.jpg';

export const productData = [
    {
        img: product1,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to Cart'
    },

    {
        img: product2,
        alt: 'Pizza',
        name: 'Hawaiian Paradise',
        desc: 'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to Cart'
    },

    {
        img: product3,
        alt: 'Pizza',
        name: 'Veggie Overload',
        desc: 'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$14.99',
        button: 'Add to Cart'
    }
]


export const productDataTwo = [
    {
        img: sweet1,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to Cart'
    },

    {
        img: sweet2,
        alt: 'Pizza',
        name: 'Hawaiian Paradise',
        desc: 'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to Cart'
    },

    {
        img: sweet3,
        alt: 'Pizza',
        name: 'Veggie Overload',
        desc: 'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$14.99',
        button: 'Add to Cart'
    }
]